import { Navigate } from 'react-router-dom'
import { PARCEIROS_HOME_PATH } from '@/pages/parceiros/parceirosNav'

export default function PortalIndicacoes() {
  return <Navigate to={PARCEIROS_HOME_PATH} replace />
}
